export default __webpack_public_path__ + "static/media/kmp-logo-3.028dde6d.webp";